import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {JavascriptRoutingModule} from "./javascript-routing.module";
import {JavascriptComponent} from "./javascript.component";
import {SharedModule} from "../shared/shared.module";
import {FormsModule} from "@angular/forms";

@NgModule ({
  declarations: [
    JavascriptComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    JavascriptRoutingModule,
    SharedModule
  ],
  exports: [],
  providers: []
})

export class JavascriptModule {

}



// WEBPACK FOOTER //
// ./src/app/javascript/javascript.module.ts